import axios from '_u/axios'

// 查询已授權资源列表
export const resTree = (userId) => {
    return axios.post('api/sys/resource/queryAuth', { userId })
}

// 查询资源树列表
export const resList = () => {
	return axios.post('api/sys/resource/list')
}

// 新增资源
export const resAdd = (data) => {
	return axios.post('api/sys/resource/add', data)
}

// 修改资源
export const resUpdate = (data) => {
	return axios.post('api/sys/resource/update', data)
}

// 删除资源
export const resDelete = (id) => {
	return axios.post('api/sys/resource/delete', { id })
}

// 查询用户拥有的资源
export const resUser = (id) => {
	return axios.post('api/sys/resource/user', {
		id
	})
}

// 修改资源排序
export const resSort = (id, doType) => {
	return axios.post('api/sys/resource/sort', {
		id,
		doType // 1置顶，2：置底，3：上移 ，4：下移
	})
}

// 查询子级资源
export const resChild = (id, prodId) => {
	return axios.post('api/sys/resource/child', {
		id,
		prodId
	})
}

// 查询资源明细
export const resView = (id) => {
	return axios.post('api/sys/resource/view', { id })
}

// 授权
export const orgAuth = (body) => {
	return axios.post('api/sys/org/auth', body)
}

// 授权案场列表
export const projQueryAll = (userId) => {
	return axios.post('api/sys/proj/queryAll', { userId })
}

// 批量新增菜单
export const resBatchAdd = (body) => {
	// pid:
	// list:[{title:''…..}]
	return axios.post("api/sys/resource/addBatch", body)
}

// 查询列表
export const accessList = () => {
	return axios.post("api/data/access/list")
}

// 授权
export const doAuth = (body) => {
	return axios.post("api/data/access/doAuth", body)
}

// 数据授权
export const queryAuth = (module) => {
	return axios.post("api/data/access/queryAuth", {module})
}

// 微信资源菜单
export const wxList = () => {
    return axios.post('api/sys/resource/wxList')
}
